export default [
  {
    name: 'ad_manage',
    path: '/ad_manage',
    component: () => import('./ADManage.vue')
  }
]
